import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, BRAND, CONTACTS } from "../data/content";

const Navbar = ({ onCTAClick }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 bg-cream/95 backdrop-blur-md transition-shadow duration-300 ${
        scrolled ? "border-b-2 border-burgundy/30 shadow-[0_2px_0_0_rgba(74,20,25,0.08)]" : "border-b border-burgundy/15"
      }`}
      style={{ paddingTop: "env(safe-area-inset-top)" }}
      data-testid="site-navbar"
    >
      <div className="container-x flex items-center justify-between py-3.5 md:py-5">
        <button
          onClick={() => handleNav("top")}
          className="flex items-baseline gap-2 group"
          data-testid="navbar-brand"
        >
          <span className="font-heading text-3xl md:text-4xl leading-none text-burgundy tracking-wide">
            {BRAND.name}
          </span>
          <span className="text-[8px] sm:text-[10px] uppercase tracking-[0.24em] sm:tracking-[0.32em] text-muted_ink pb-1 whitespace-nowrap">
            мастерская обуви
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => handleNav(l.id)}
              className="text-sm font-medium uppercase tracking-[0.18em] text-ink/80 hover:text-burgundy transition-colors"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a
            href={`tel:${CONTACTS.phoneRaw}`}
            className="flex items-center gap-2 text-burgundy text-sm font-medium hover:text-burgundy-deep transition-colors"
            data-testid="navbar-phone"
          >
            <Phone size={16} strokeWidth={1.5} />
            {CONTACTS.phone}
          </a>
          <button
            onClick={onCTAClick}
            className="btn-primary !py-2.5 !px-5"
            data-testid="navbar-cta-request"
          >
            Заявка
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-burgundy"
          aria-label="Открыть меню"
          data-testid="navbar-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-burgundy/20 bg-cream-light" data-testid="navbar-mobile-menu">
          <div className="container-x py-6 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => handleNav(l.id)}
                className="text-left py-3 text-base uppercase tracking-[0.18em] text-ink hover:text-burgundy border-b border-burgundy/10"
                data-testid={`nav-mobile-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <a href={`tel:${CONTACTS.phoneRaw}`} className="py-3 text-burgundy" data-testid="nav-mobile-phone">
              {CONTACTS.phone}
            </a>
            <button onClick={() => { setOpen(false); onCTAClick?.(); }} className="btn-primary mt-3" data-testid="nav-mobile-cta">
              Оставить заявку
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
